module.exports = "../../static/fonts/Lato-LightItalic.3d747d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-LightItalic.ttf
// module id = 920
// module chunks = 2